import { render, staticRenderFns } from "./Portfolio-item.vue?vue&type=template&id=66258716&"
import script from "./Portfolio-item.vue?vue&type=script&lang=js&"
export * from "./Portfolio-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports